import { KeyboardArrowDownRounded } from "@mui/icons-material";
import { Box, Chip, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { info, error, mint, secondary, success, warning } from "../../../../theme/colors";
import FormList from "../../../../builderPackage/components/dynamicFormBuilder/surfaces/formList";
var data = [{
        id: 0,
        Name: 'Overdue',
        Value: 8
    }, {
        id: 1,
        Name: 'Confirmed',
        Value: 10
    }, {
        id: 2,
        Name: 'To be called back',
        Value: 6
    }, {
        id: 3,
        Name: 'Contacted',
        Value: 4
    }, {
        id: 4,
        Name: 'Follow up',
        Value: 3
    }, {
        id: 5,
        Name: 'In Service center',
        Value: 2
    }];
var colors = [error, success, info, secondary, warning, mint];
var options = [{
        id: '1',
        Name: 'Today'
    }, {
        id: '2',
        Name: 'Tomorrow'
    }, {
        id: '3',
        Name: 'Next 7 days'
    }];
export default function AppointmentsProgressBar() {
    var _a = useState(options[0].id), channel = _a[0], setChannel = _a[1];
    var handleChannelChange = function (event) {
        setChannel(event.target.value);
    };
    var totalAppointments = data.reduce(function (acc, it) { return acc + it.Value; }, 0);
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: 2,
            border: "1px solid #e0e0e0",
            borderRadius: "4xl",
            backgroundColor: "#fff",
            flexGrow: 1
            // width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "lg",
        fontWeight: "strong"
    }, "Appointments")), /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2
    }, /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        color: "secondary"
    }, "Total appointments"), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 24,
        fontWeight: "strong"
    }, totalAppointments)), /*#__PURE__*/ React.createElement(Select, {
        value: channel,
        onChange: handleChannelChange,
        size: "small",
        IconComponent: KeyboardArrowDownRounded
    }, options.map(function (it) { /*#__PURE__*/ return React.createElement(MenuItem, {
        value: it.id
    }, it.Name); }))), /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        gap: 0.5,
        overflow: "hidden",
        height: 8,
        borderRadius: 2,
        my: 2
    }, data.map(function (item, index) { /*#__PURE__*/ return React.createElement(Box, {
        key: item.id,
        sx: {
            width: "".concat(item.Value * 100 / totalAppointments, "%"),
            backgroundColor: colors[item.id][500]
        }
    }); })), /*#__PURE__*/ React.createElement(FormList, {
        name: "",
        value: data,
        columns: [{
                type: 'string',
                field: 'Color',
                maxWidth: 40,
                flex: 1,
                align: 'right',
                renderCell: function (_ref) {
                    var row = _ref.row;
                    return /*#__PURE__*/ React.createElement(Box, {
                        bgcolor: colors[row.id][500],
                        borderRadius: "100%",
                        width: 10,
                        height: 10,
                        ml: "auto",
                        my: 0
                    });
                }
            }, {
                type: 'string',
                field: 'Name',
                flex: 1
            }, {
                type: 'number',
                field: 'Value',
                width: 60,
                align: 'center',
                renderCell: function (_ref2) {
                    var value = _ref2.value, row = _ref2.row;
                    return /*#__PURE__*/ React.createElement(Chip, {
                        label: value,
                        variant: "outlined",
                        size: "small",
                        sx: {
                            borderColor: colors[row.id][500],
                            background: colors[row.id][50],
                            color: colors[row.id][500]
                        }
                    });
                }
            }],
        apiKey: "_",
        disableCheckboxSelection: true,
        disableDetailsPanel: true,
        rowHeight: 42,
        variant: "compact",
        disableBorder: true
    }));
}
